import React from 'react'
import {Link} from 'react-router-dom'

const CustomLink = ({outline, primary, small, medium, secondary, right, cart, className, ...rest}) => {
  const buttonClass =  [
    'g-profile__button g-content-shadow',
    outline && 'g-profile__button--border border-primary primary-text',
    right &&'g-profile__button--right',
    primary &&'primary-bg text-color',
    secondary &&'secondary-bg text-color',
    cart && 'g-profile__button--cart',
    small && 'g-profile__button--small',
    medium && 'g-profile__button--medium g-profile__button--secondary',
    className
  ].join(' ')

  return (
    <Link className={buttonClass} {...rest}/>
  )
}

export default CustomLink